module.exports = __webpack_public_path__ + "static/img/PS-JC.70b6631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PS-JC.png
// module id = OlMP
// module chunks = 1